module.exports = __webpack_public_path__ + "img/blur-video.094b682.png";